/**
 * 店铺品牌配置在 localStorage 中的存储 key
 * 用于页面刷新后恢复 vuex 状态，避免品牌判断丢失
 */
const BRAND_CONFIG_STORAGE_KEY = 'mshop_brand_config';

/**
 * 默认品牌配置（空状态）
 */
function getDefaultBrandConfig() {
  return {
    shopId: '',
    storeCode: '',
    brandType: '',         // 品牌标识（保留用于调试，前端逻辑不依赖此字段）
    brandName: '',
    storeType: '',
    userCode: '',          // 用户标识，用于检测账号切换
    loginTime: 0,          // 登录时间戳，用于检测同账号重新登录
    isHaidilao: false,     // 海底捞
    isDanBo: false,        // 蛋啵
    isXjch: false,         // 薛记炒货
    isZhongfu: false,      // 中福工艺品
    isCjnc: false,         // 茶姬奶茶
    isCjncDemo: false,     // 茶姬奶茶演示（cjnc1）
    isTgg: false,          // 酸奶罐罐
    isZuimian: false,      // 醉面
    isHls: false,          // 华莱士
    isDtbx: false,         // 大童保险
    isYh: false            // 益好商城
  };
}

/**
 * 从 localStorage 读取品牌配置
 * 页面刷新后 vuex 会重置，需要从 localStorage 恢复
 */
function loadBrandConfigFromStorage() {
  try {
    const stored = localStorage.getItem(BRAND_CONFIG_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // 合并默认值，避免旧版本缓存缺少新字段
      return Object.assign(getDefaultBrandConfig(), parsed);
    }
  } catch (e) {
    console.warn('[brandConfig] 读取 localStorage 缓存失败', e);
  }
  return getDefaultBrandConfig();
}

/**
 * 模块加载时预先从 localStorage 读取品牌配置
 * 用于初始化 state.brandConfig 以及同步顶层的 isHaidilao/isDanBo/isxjch/isZhongfu
 * 这样页面刷新后 vuex 重置，顶层布尔标志也能立即恢复，无需等待 setBrandConfig action 触发
 */
const initialBrandConfig = loadBrandConfigFromStorage();

const app = {
  state: {
      theme:{
        colors: ['#EF4056', '#ff4e48', '#EF4056'],
        format: {
          name: 'format-1',
          tabbarIcons:{
            home: 'homel',
            homeOn: 'homeF',
            category: 'storel',
            categoryOn: 'storef',
            cart: 'cartl',
            cartOn: 'cartf',
            user: 'mainl',
            userOn: 'mainf',
          }
        }
      },
      storeType: '',
      openId: '',
      token: '',
      shopId: '',
      ifEnterpriseGoods:'',
      enterpriseCode:'',
      phone:'',//绑定手机号
      userName:'',
      nickName: '',
	    maxNum: '',//保险公司用户最多下单数量
	    areadyNum: '',//保险公司用户已下单数量
      headImgUrl: '', // 微信用户头像URL
      styleTheme:'',//列表页展示样式类型
      shopName:'',//店铺名，用于展示店铺名称
      logo:'',//logo地址
      isZhongfu: initialBrandConfig.isZhongfu || false,//中福工艺品（从 brandConfig 同步）
      currentAlbum: { // 云协作相册,当前操作的相册信息
        name: { // 相册名称
          type: String,
          required: true
        },
        cooperaterNumber: { // 协作成员数量
          type: Number,
          required: true
        },
        albumId: String, // 相册ID
        coverPage: String, // 封面图片URL
        albumSku: String, // 相册关联商品的SKU
        albumPageNum: Number, // 相册P数
        templateId: String, // 模板ID
        albumStatus: String, // 相册状态
      },
      industryCode: '', // 行业code(门店)
      vipState: false, // 是否是vip(门店)
      userCode: '', // 用户code
      isDanBo: initialBrandConfig.isDanBo || false,//判断是蛋啵进入（从 brandConfig 同步）
      isHaidilao: initialBrandConfig.isHaidilao || false,//判断是海底捞（从 brandConfig 同步）
      isZuimian: initialBrandConfig.isZuimian || false,//判断是醉面（从 brandConfig 同步）
      isxjch: initialBrandConfig.isXjch || false,//判断是否是薛记炒货月结的（从 brandConfig 同步）
      designId:'',//蛋啵重新推送设计id
      ogId:'',//蛋啵重新推送订单商品code
      // ========== 后端下发的店铺品牌配置 ==========
      // 页面刷新后 vuex 重置，初始值从 localStorage 恢复，保证品牌判断不丢失
      brandConfig: initialBrandConfig,
  },
  mutations: {
    // 主题
    SET_THEME_COLORS: (state, colors) => {
      state.theme.colors = colors
    },
    SET_THEME_FORMAT: (state, format) => {
      state.theme.format = format
    },
    SET_STORE_TYPE: (state, storeType) => {
      state.storeType = storeType
    },
    SET_AREADY_NUM: (state, areadyNum) => {
      state.areadyNum = areadyNum
    },
    SET_MAX_NUM: (state, maxNum) => {
      state.maxNum = maxNum
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
    SET_NICK_NAME: (state, nickName) => {
      state.nickName = nickName
    },
    SET_HEAD_IMG_URL: (state, headImgUrl) => {
      state.headImgUrl = headImgUrl
    },
    SET_STYLE_THEME: (state, styleTheme) => {
      state.styleTheme = styleTheme
    },
    SET_SHOP_NAME: (state, shopName) => {
      state.shopName = shopName
    },
    SET_CHILD_SHOP_NAME: (state, childShopName) => {
        state.childShopName = childShopName
    },
    SET_CHILD_SHOP_CODE: (state, childShopCode) => {
        state.childShopCode = childShopCode
    },
    SET_LOGO: (state, logo) => {
        state.logo = logo
    },
    SET_CURRENT_ALBUM: (state, currentAlbum) => {
      state.currentAlbum = JSON.parse(JSON.stringify(currentAlbum));
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone;
    },
    SET_OPEN_ID: (state, openid) => {
      state.openId = openid;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_SHOP_ID: (state, shopId) => {
      state.shopId = shopId;
    },
    SET_ENTERPRISE: (state, ifEnterpriseGoods ) => {
      state.ifEnterpriseGoods = ifEnterpriseGoods;
    },
    SET_ENTERPRISECODE: (state, enterpriseCode ) => {
      state.enterpriseCode = enterpriseCode;
    },
    SET_INDUSTRY_CODE: (state, industryCode ) => {
      state.industryCode = industryCode;
    },
    SET_VIP_STATE: (state, vipState ) => {
      state.vipState = vipState;
    },
    SET_USER_CODE: (state, userCode ) => {
      state.userCode = userCode;
    },
    SET_ISDANBO: (state, isDanBo) => {
      state.isDanBo = isDanBo;
    },
    SET_ISHAIDILAO: (state, isHaidilao) => {
      state.isHaidilao = isHaidilao;
    },
    SET_ISZUIMIAN: (state, isZuimian) => {
      state.isZuimian = isZuimian;
    },
    SET_DESIGNID: (state, designId) => {
      state.designId = designId;
    },
    SET_OGID: (state, ogId) => {
      state.ogId = ogId;
    },
    SET_IS_ZHONGFU: (state, isZhongfu) => {
      state.isZhongfu = isZhongfu;
    },
    SET_IS_XJCH: (state, isxjch) => {
      state.isxjch = isxjch;
    },

    /**
     * 设置店铺品牌配置（整体替换）
     * 同步写入 localStorage，保证页面刷新后 vuex 重置时仍可恢复
     */
    SET_BRAND_CONFIG: (state, brandConfig) => {
      state.brandConfig = Object.assign({}, state.brandConfig, brandConfig);
      // 同步持久化到 localStorage，刷新页面后从初始化函数 loadBrandConfigFromStorage() 恢复
      try {
        localStorage.setItem(BRAND_CONFIG_STORAGE_KEY, JSON.stringify(state.brandConfig));
      } catch (e) {
        console.warn('[brandConfig] 写入 localStorage 缓存失败', e);
      }
    },

    /**
     * 重置品牌配置（登出时调用）
     * 同时清除 localStorage 缓存与 vuex 顶层布尔标志，避免下次登录残留
     */
    RESET_BRAND_CONFIG: (state) => {
      state.brandConfig = getDefaultBrandConfig();
      // 同步重置顶层布尔标志（这些字段被 App.vue / detail.vue / order-confirm.vue 等多处使用）
      state.isHaidilao = false;
      state.isZuimian = false;
      state.isDanBo = false;
      state.isxjch = false;
      state.isZhongfu = false;
      try {
        localStorage.removeItem(BRAND_CONFIG_STORAGE_KEY);
      } catch (e) {
        console.warn('[brandConfig] 清除 localStorage 缓存失败', e);
      }
    },

  },
  actions: {
    // 主题
    setThemeColors({ commit }, colors) {
      commit('SET_THEME_COLORS', colors)
    },
    setThemeFormat({ commit }, format) {
      commit('SET_THEME_FORMAT', format)
    },
    setStoreType({ commit }, storeType) {
      commit('SET_STORE_TYPE', storeType)
    },
    setNickName({ commit }, nickName) {
      commit('SET_NICK_NAME', nickName)
    },
    setHeadImgUrl({ commit }, headImgUrl) {
      commit('SET_HEAD_IMG_URL', headImgUrl)
    },
    setStyleTheme({ commit }, styleTheme) {
      commit('SET_STYLE_THEME', styleTheme)
    },
    setShopName({ commit }, shopName) {
      commit('SET_SHOP_NAME', shopName)
    },
    setChildShopCode({ commit }, childShopCode) {
      commit('SET_CHILD_SHOP_CODE', childShopCode)
    },
    setLogo({ commit }, logo) {
      commit('SET_LOGO', logo)
    },
    setChildShopName({ commit }, childShopName) {
      commit('SET_CHILD_SHOP_NAME', childShopName)
    },
    setCurrentAlbum({ commit }, currentAlbum) {
      commit('SET_CURRENT_ALBUM', currentAlbum)
    },
    setMaxNum({ commit }, maxNum) {
      commit('SET_MAX_NUM', maxNum)
    },
    setAreadyNum({ commit }, areadyNum) {
      commit('SET_AREADY_NUM', areadyNum)
    },
    setUserName({ commit }, userName) {
      commit('SET_USER_NAME', userName)
    },
    setPhone({ commit }, phone) {
      commit('SET_PHONE', phone)
    },
    setOpenId({ commit }, openId) {
      commit('SET_OPEN_ID', openId)
    },
    setShopId({ commit }, shopId) {
      commit('SET_SHOP_ID', shopId)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setIfEnterpriseGoods({ commit }, ifEnterpriseGoods) {
      commit('SET_ENTERPRISE', ifEnterpriseGoods)
    },
    setEnterpriseCode({ commit }, enterpriseCode) {
      commit('SET_ENTERPRISECODE', enterpriseCode)
    },
    setIndustryCode({ commit }, industryCode) {
      commit('SET_INDUSTRY_CODE', industryCode)
    },
    setVipState({ commit }, vipState) {
      commit('SET_VIP_STATE', vipState)
    },
    setUserCode({ commit }, userCode) {
      commit('SET_USER_CODE', userCode)
    },
    setIsDanBo({ commit }, isDanBo) {
      commit('SET_ISDANBO', isDanBo)
    },
    setIsHaidilao({ commit }, isHaidilao) {
      commit('SET_ISHAIDILAO', isHaidilao)
    },
    setDesignId({ commit }, designId) {
      commit('SET_DESIGNID', designId)
    },
    setOgId({ commit }, ogId) {
      commit('SET_OGID', ogId)
    },
    setIsZhongfu({ commit }, isZhongfu) {
      commit('SET_IS_ZHONGFU', isZhongfu)
    },
    setIsxjch({ commit }, isxjch) {
      commit('SET_IS_XJCH', isxjch)
    },

    /**
     * 设置店铺品牌配置
     * 同时把品牌布尔标志（isHaidilao/isDanBo/isxjch 等）也同步到 state
     */
    setBrandConfig({ commit }, brandConfig) {
      commit('SET_BRAND_CONFIG', brandConfig);
      // 同步品牌布尔标志
      if (brandConfig) {
        if (brandConfig.isHaidilao !== undefined) commit('SET_ISHAIDILAO', brandConfig.isHaidilao);
        if (brandConfig.isZuimian !== undefined) commit('SET_ISZUIMIAN', brandConfig.isZuimian);
        if (brandConfig.isDanBo !== undefined) commit('SET_ISDANBO', brandConfig.isDanBo);
        if (brandConfig.isXjch !== undefined) commit('SET_IS_XJCH', brandConfig.isXjch);
        if (brandConfig.isZhongfu !== undefined) commit('SET_IS_ZHONGFU', brandConfig.isZhongfu);
      }
    },

    /**
     * 重置品牌配置（登出时调用）
     */
    resetBrandConfig({ commit }) {
      commit('RESET_BRAND_CONFIG');
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js